export default __webpack_public_path__ + "static/media/WCDownstairs.026e798e.png";